<!-- eslint-disable max-len -->
<template>
  <div
    v-if="status"
    class="card mb-3 fork-sync"
  >
    <div
      class="d-flex flex-column flex-sm-row justify-content-between align-items-center py-2 px-3 bg-light"
    >
      <div class="">
        Эта ветка
        <template v-if="status">
          <span v-if="status.commitsBehind > 0">
            отстает на
            <a :href="`${forkLink}/commit?branch=${status.branchName}`">
              <span v-if="status.commitsBehind % 10 === 1">{{ status.commitsBehind }} коммит</span>
              <span v-else-if="status.commitsBehind > 99">99+ коммитов</span>
              <span
                v-else-if="
                  status.commitsBehind < 5 ||
                  (status.commitsBehind > 20 && status.commitsBehind % 10 < 5)
                "
              >
                {{ status.commitsBehind }} коммитa
              </span>
              <span v-else>{{ status.commitsBehind }} коммитов</span>
            </a>
          </span>
          <span v-if="status.commitAhead > 0">
            опережает на
            <a :href="`${$route.path}/commit`">
              <span v-if="status.commitAhead % 10 === 1">{{ status.commitAhead }} коммит</span>
              <span v-else-if="status.commitsBehind > 99">99+ коммитов</span>
              <span
                v-else-if="
                  status.commitsBehind < 5 ||
                  (status.commitsBehind > 20 && status.commitsBehind % 10 < 5)
                "
              >
                {{ status.commitAhead }} коммитa
              </span>
              <span v-else>{{ status.commitAhead }} коммитов</span>
            </a>
          </span>
        </template>
        <span v-if="status.commitsBehind === 0 && status.commitAhead === 0">актуальна</span>
      </div>

      <div
        v-if="status.canSync && status.commitsBehind > 0"
        class="mr-1"
      >
        <button
          class="d-flex align-items-center btn btn-primary btn-sm"
          type="button"
          @click="openSyncForkModal"
        >
          <i class="gf-icon gf-icon-reload mr-1"></i>
          Синхр. форк
        </button>

        <gf-custom-modal-window
          ref="gfCustomModalWindowSyncFork"
          gf-modal-data-name="syncForkModal"
          gf-modal-header="Синхронизировать форк"
          gf-modal-wrapper-width="600px"
        >
          <template #body>
            <div class="mb-3 d-flex flex-column gap-3">
              <b>Текущая ветка устарела</b>
              <gf-custom-alert
                v-if="status?.mergeConflicts"
                variant="danger"
              >
                <template #body>
                  <span>
                    Изменения исходной версии не удалось синхронизировать с этим проектом из-за
                    конфликтов. Вы можете разрешить конфликты вручную или принять все изменения в
                    пользу основного репозитория.
                  </span>
                </template>
              </gf-custom-alert>

              <gf-custom-alert
                v-if="hasLockConflicts"
                variant="warning"
              >
                <template #body>
                  <div>
                    Невозможно обновить ветку из-за конфликтов в заблокированных файлах:
                    <button
                      type="button"
                      class="btn btn-sm py-0 px-1 ml-1"
                      @click="isLockConflictsOpened = !isLockConflictsOpened"
                    >
                      <i :class="isOpenedLocksConflictsIcon"></i>
                    </button>
                  </div>
                  <div
                    v-if="isLockConflictsOpened"
                    class="mt-3"
                  >
                    <div
                      v-for="(conflict, index) in status.lockConflicts"
                      :key="index"
                      class="mt-1"
                    >
                      {{ index + 1 }}.&nbsp;
                      <i class="gf-icon gf-icon-file merge-area__file-icon"></i>
                      {{ conflict?.filePath }} заблокирован @{{ conflict?.lockedBy }}
                    </div>
                  </div>
                </template>
              </gf-custom-alert>
              <p v-else>
                <b>Обновите, чтобы актуализировать ветку</b>
              </p>
            </div>
            <div class="d-flex justify-content-end border-top pt-3">
              <button
                type="button"
                class="btn btn-dark btn-sm m-1"
                @click="closeSyncForkModal"
              >
                {{ $t('message.cancel') }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm m-1"
                :disabled="hasLockConflicts"
                @click="fetchBranch"
              >
                Обновить ветку
              </button>
            </div>
          </template>
        </gf-custom-modal-window>
      </div>
    </div>
  </div>
</template>

<script>
import RepoS from '@shared/services/repository.service';
import GfCustomAlert from '@/shared-modules/shared-components/shared/GfCustomAlert';
import gfCustomModalWindow from '@shared/shared-components/shared/GfCustomModalWindow';

export default {
  name: 'ForkInformation',
  components: {
    GfCustomAlert,
    gfCustomModalWindow
  },
  props: ['branch', 'forkLink'],
  data() {
    return {
      status: null,
      isLockConflictsOpened: false
    };
  },
  computed: {
    hasLockConflicts() {
      return this.status?.lockConflicts?.length > 0;
    },
    isOpenedLocksConflictsIcon() {
      return this.isLockConflictsOpened ? 'gf-icon-chevron-up' : 'gf-icon-chevron-down';
    }
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    getStatus() {
      RepoS.getForkStatus(this.$route.params.alias, this.$route.params.projectAlias, {
        branch: this.branch
      }).then((res) => {
        this.status = res;
      });
    },
    fetchBranch() {
      if (!this.hasLockConflicts) {
        RepoS.fetchFork(
          this.$route.params.alias,
          this.$route.params.projectAlias,
          {
            branch: this.branch
          },
          {}
        ).then(() => {
          window.location.reload();
        });
      }
    },
    openSyncForkModal() {
      this.$refs.gfCustomModalWindowSyncFork.openModalWindow();
    },
    closeSyncForkModal() {
      this.$refs.gfCustomModalWindowSyncFork.closeModalWindow();
    }
    // fetchAllBranches() {
    //   RepoS.fetchFork(
    //       this.$route.params.alias,
    //       this.$route.params.projectAlias,
    //       {},
    //       {},
    //   ).then(() => {
    //     location.reload();
    //   })
    // }
  }
};
</script>

<style lang="scss">
.fork-sync {
  .btn {
    white-space: nowrap;
  }
}
</style>
